import "./index.scss";
import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";
import { Box, Button, Icons, Typography } from "fds";
import DividerIcon from "../../shared/icons/DividerIcon";
import { DocInfo, UploadFile } from "../../types/files";
import { getUserInfoFromLocalStorage } from "../../shared/utils/auth";
import { LoginDto } from "../../types/auth";
import useAppStore from "../../redux/dispatcher/useAppStore";
import useDocumentStore from "../../redux/dispatcher/useDocumentStore";
import WrapIcon from "../../shared/icons/WrapIcon";
import DropboxList from "./Dropbox";
import WorkgroupAddModal from "../WorkgroupAddModal";

export type PRODUCT_ITEM_TYPE = "zoom" | "outlook" | "googleDrive" | "dropbox";
interface LinkAppProps {
  target: PRODUCT_ITEM_TYPE;
  changeTarget: (target: PRODUCT_ITEM_TYPE) => void;
  open: boolean;
  onDragStart: (event: any) => void;
  dragFiles: DocInfo[];
  onDropFile?: any;
  openCreateWorkgroupModal: (type: string) => void;
  onClose: () => void;
  onDragOverFile?: any;
}
export const PRODUCT_NAME = {
  zoom: "Zoom",
  outlook: "Outlook",
  googleDrive: "Google Drive",
  dropbox: "Dropbox",
} as { [key in PRODUCT_ITEM_TYPE]: string };

const LinkAppPortal: React.FC<LinkAppProps> = ({
  target,
  open,
  changeTarget,
  onDragStart,
  onDropFile,
  dragFiles,
  openCreateWorkgroupModal,
  onDragOverFile,
  onClose,
}) => {
  const { t } = useTranslation();
  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto = JSON.parse(user) as LoginDto;
  const { appState } = useAppStore();
  const {
    getDocUploadUidCreate,
    setAddUploadProgressFiles,
    setUpdateUploadProgressFiles,
  } = useDocumentStore();
  const { uploadDropboxToEco } = useAppStore();
  const [openFileUploadModal, toggleOpenFileUploadModal] = useState(false);
  const [currentPath, changeCurrentPath] = useState("root");

  const handleUploadFilesInUID = async (
    selectedList: string[],
    fileList: { id: string; size: number; name: string }[],
    type: "GOOGLE" | "DROPBOX"
  ): Promise<void> => {
    const res = await getDocUploadUidCreate();
    const targetUid: string = "" + res.payload;
    const uuid = uuidv4();
    toggleOpenFileUploadModal(true);
    fileList
      .filter((item) => selectedList.includes(item.id))
      .forEach(async (targetFile, index) => {
        const file = targetFile;
        const uploadFile: UploadFile = {
          isMultiple: true,
          uuid: uuid + index,
          fileName: file.name,
          fileSize: file.size,
          workgroupId: "",
          workgroupName: "",
          status: "WAIT", // WAIT, ING, SUCCESS, FAIL
          errorMsg: "",
          fileType: type,
        };
        setAddUploadProgressFiles(uploadFile);
      });
    fileList
      .filter((item) => selectedList.includes(item.id))
      .forEach(async (file, index) => {
        const fileExt = file.name.split(/[.]+/).pop();
        let msg = "";
        let checkExt = true;
        const size =
          typeof file.size === "string" ? parseInt(file.size) : file.size;
        setUpdateUploadProgressFiles({
          uuid: uuid + index,
          fileName: file.name,
          fileId: file.id,
          fileSize: size,
          workgroupId: "",
          workgroupName: "",
          status: "ING", // WAIT, ING, SUCCESS, FAIL
          fileType: type,
          errorMsg: "",
        });
        if (
          !fileExt ||
          (loginDto.serviceConfig.allowedExtensions &&
            loginDto.serviceConfig.allowedExtensions?.length > 0 &&
            !loginDto.serviceConfig.allowedExtensions?.includes(fileExt))
        ) {
          msg = t("file.alert.notSupportedExt"); // by iris
          checkExt = false;
        } else if (
          (!loginDto.serviceConfig.allowedExtensions ||
            loginDto.serviceConfig.allowedExtensions?.length === 0) &&
          loginDto.serviceConfig.disableExtensions.includes(fileExt)
        ) {
          msg = t("file.alert.notSupportedExt"); // by iris
          checkExt = false;
        } else if (file.size === 0) {
          //msg = '0KB 크기의 파일은 업로드 할 수 없습니다.';
          msg = t("file.alert.notAllowZeroSize"); // by iris
          checkExt = false;
        } else if (
          loginDto &&
          size > loginDto.ecoCommonConfig.fileUploadMaxSizeMB * 1024 * 1024
        ) {
          //msg = loginDto.ecoCommonConfig.fileUploadMaxSizeMB + 'MB 이하의 파일만 업로드 가능합니다.';
          msg = t("file.alert.notAllowMaxSize", {
            num: loginDto.ecoCommonConfig.fileUploadMaxSizeMB,
          });
          checkExt = false;
        }
        let resp: any;
        resp = await uploadDropboxToEco({
          uid: targetUid,
          fileId: file.id,
          name: file.name,
        });
        setUpdateUploadProgressFiles({
          uuid: uuid + index,
          fileName: file.name,
          fileId:
            resp.payload && resp.payload.entity
              ? resp.payload.entity.fileId
              : file.id ?? "",
          fileSize: size,
          workgroupId: "",
          workgroupName: "",
          status: checkExt && resp.payload ? "SUCCESS" : "FAIL", // WAIT, ING, SUCCESS, FAIL
          fileType: type,
          errorMsg: msg ? msg : resp.error ? resp.error.message : "",
        });
      });
  };
  return (
    <Box classes={classNames("linkAppPortal", { open: open })}>
      {openFileUploadModal && (
        // <FileUploadModal
        //   open={openFileUploadModal}
        //   type="DROPBOX"
        //   onClose={() => {
        //     setUpdateUploadProgressFiles({} as UploadFile);
        //     toggleOpenFileUploadModal(false);
        //   }}
        //   // moveToCreateWorkgroup={() => {
        //   //   openCreateWorkgroupModal("file");
        //   //   toggleOpenFileUploadModal(false);
        //   // }}
        // />
        <WorkgroupAddModal
          createType={"SEND_FILE"}
          open={openFileUploadModal}
          targetType={"DROPBOX"}
          onClose={() => {
            setUpdateUploadProgressFiles({} as UploadFile);
            toggleOpenFileUploadModal(false);
          }}
        />
      )}
      <Box classes="linkAppPortal-header ">
        <WrapIcon />
        <DividerIcon direction="col" />
        {["dropbox"]
          .filter((app) => {
            return (
              // (app === 'outlook' && imapLoginInfo) ||
              (app === "googleDrive" &&
                appState.appRegisterStatus.googleDrive) ||
              (app === "zoom" && appState.appRegisterStatus.zoom) ||
              (app === "dropbox" && appState.appRegisterStatus.dropbox)
            );
          })
          .map((item) => (
            <Button
              btnStyle="icon"
              state="clicked"
              onClick={() => changeTarget(item as PRODUCT_ITEM_TYPE)}
              key={"linkApp" + item}
              leadingIcon={
                <img
                  src={require(`../../shared/images/logo/${item}20.png`)}
                  alt={item}
                />
              }
            ></Button>
          ))}
        <Button
          // height={32}
          // transparent
          btnStyle="icon"
          onClick={onClose}
          leadingIcon={<Icons variant="line" label="closeLarge" />}
          classes="mg ml-auto"
        ></Button>
      </Box>
      {dragFiles && dragFiles?.filter((item) => !!item.syncId).length > 0 && (
        <div
          className="linkAppPortal-dropzone"
          onDragOver={(e) => onDragOverFile(e, true)}
          onDrop={(e) => onDropFile(e, true, "upload", currentPath)}
          id="linkAppPortal-dropzone"
        >
          <img
            src={require("../../shared/images/pages/File/UploadFile.png")}
            alt="upload"
          />
          <Typography type="h3" classes="mg mt-24" exactColor="white">
            {t("file.dropHere")}
          </Typography>
          <Typography type="body2_rg" classes="mg mt-16" exactColor="white">
            {t("account.app.uploadToDrive", { name: "Dropbox" })}
          </Typography>
        </div>
      )}

      {/* {target === "googleDrive" ? (
        <GoogleDriveList
          onDragStart={onDragStart}
          openCreateWorkgroupModal={openCreateWorkgroupModal}
          handleUploadFilesInUID={handleUploadFilesInUID}
          changeCurrentPath={changeCurrentPath}
        />
      ) : target === "dropbox" ? ( */}
      <DropboxList
        onDragStart={onDragStart}
        openCreateWorkgroupModal={openCreateWorkgroupModal}
        handleUploadFilesInUID={handleUploadFilesInUID}
        changeCurrentPath={changeCurrentPath}
        currentPath={currentPath}
      />
    </Box>
  );
};

export default LinkAppPortal;
